import { colors } from '~/common/theme';
import { indigoColors } from '~/common/theme/indigo.colors';

export const CHART_COLORS = [
  indigoColors.purple[500],
  indigoColors.cyan[500],
  indigoColors.green[500],
  colors.gray[500],
];
